<div [ngClass]="{ disabled_btn: isDisabled || isLoading }">
  <button
    *ngIf="!isHidden"
    class="gap-2 h-9 text-base"
    [ngClass]="{ fab_button: fab }"
    [type]="type"
    [attr.data-qa]="dataQA"
    [pTooltip]="tooltip || fab ? tooltip || (label ?? '') : ''"
    [disabled]="isDisabled"
    (click)="onClick()"
    tooltipPosition="bottom"
  >
    <elio-svg-icon
      *ngIf="isLoading"
      class="text-lg animate-spin font-normal text-white h-9"
      key="cutted-circle"
    ></elio-svg-icon>
    <elio-svg-icon *ngIf="icon" class="text-lg rotate-{{ iconRotation }}" [key]="icon" data-cy="icon"></elio-svg-icon>
    <span *ngIf="label && !fab" class="text-md text-left whitespace-nowrap !leading-4">{{ label }}</span>
  </button>
</div>
